import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { installApiFetchBridge } from "./api-runtime";
import "../../app/styles/tokens.css";
import "../../app/styles/foundation.css";
import "../../app/styles/stage8-password.css";
import "../../app/styles/stage19-loading-runtime.css";
import "./static-runtime.css";
import "./workspace-core.css";
import "../../app/styles/hover-scrollbars.css";
import { workspaceRouteKey } from "../../lib/workspace-navigation";

installApiFetchBridge();

const initialSearch = new URLSearchParams(window.location.search);
if (workspaceRouteKey(initialSearch.get("view"), initialSearch.get("section")) !== "positions-allocation") {
  void import("./legacy-workspace-styles");
}

const root = document.getElementById("root");
if (!root) throw new Error("Static application root is missing");
createRoot(root).render(<StrictMode><App /></StrictMode>);
